export const RESET = 'EXSBDOCUMENTTYPE_LIST_RESET'
export const SET_ITEMS = 'EXSBDOCUMENTTYPE_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBDOCUMENTTYPE_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBDOCUMENTTYPE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBDOCUMENTTYPE_LIST_TOGGLE_LOADING'
